import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: {
            id: 'Layer_1',
            x: '0px',
            y: '0px',
            viewBox: '0 0 500 500',
            style: 'enable-background:new 0 0 500 500;',
        },
        child: [
            {
                tag: 'g',
                attr: { id: 'surface1' },
                child: [
                    {
                        tag: 'path',
                        attr: {
                            d: 'M89.3,39.7C62,39.7,39.7,62,39.7,89.3v317.5c0,27.3,22.3,49.6,49.6,49.6h317.5c27.3,0,49.6-22.3,49.6-49.6V89.3   c0-27.3-22.3-49.6-49.6-49.6H89.3z M89.3,59.5h65.3C119.1,96.4,99.2,144,99.2,193.5c0,51.2,20.9,100.2,58.6,137.3   c1.2,2.1,2.2,12.3-2.4,24.1c-2.9,7.4-8.6,17.2-19.8,20.9c-4.3,1.4-7.1,5.5-6.7,10c0.3,4.5,3.6,8.3,7.9,9.1   c28.5,5.7,46.9-2.9,61.8-9.6c13.4-6.1,22.2-10.3,35.8-4.8c27.8,10.9,57.4,16.4,87.9,16.4c40.6,0,79.7-9.9,114.1-28.6v38.6   c0,16.5-13.2,29.8-29.8,29.8H89.3c-16.5,0-29.8-13.2-29.8-29.8V89.3C59.5,72.7,72.7,59.5,89.3,59.5z M327.4,148.8   c5.5,0,9.9,4.5,9.9,9.9V248c0,5.5-4.5,9.9-9.9,9.9c-5.5,0-9.9-4.5-9.9-9.9v-89.3C317.5,153.3,321.9,148.8,327.4,148.8z    M178.6,158.7h49.6c3.6,0,6.9,2,8.7,5.2c1.7,3.1,1.6,6.9-0.3,10l-40.1,64.2h31.7c5.5,0,9.9,4.5,9.9,9.9s-4.5,9.9-9.9,9.9h-49.6   c-3.6,0-6.9-2-8.7-5.2c-1.7-3.1-1.6-6.9,0.3-10l40.1-64.2h-31.7c-5.5,0-9.9-4.5-9.9-9.9C168.7,163.2,173.1,158.7,178.6,158.7z    M272.8,188.5c6,0,11.7,1.7,16.7,4.5c1.8-2.6,4.6-4.5,8.1-4.5c5.5,0,9.9,4.5,9.9,9.9V248c0,5.5-4.5,9.9-9.9,9.9   c-3.5,0-6.2-1.9-8.1-4.5c-5,2.8-10.7,4.5-16.7,4.5c-19.1,0-34.7-15.6-34.7-34.7S253.7,188.5,272.8,188.5z M381.9,188.5   c19.1,0,34.7,15.6,34.7,34.7s-15.6,34.7-34.7,34.7s-34.7-15.6-34.7-34.7S362.8,188.5,381.9,188.5z M272.8,208.3c-1,0-2,0.1-3,0.3   c-2,0.4-3.8,1.2-5.3,2.2c-1.6,1.1-2.9,2.4-4,4c-1,1.6-1.8,3.4-2.2,5.3c-0.2,1-0.3,1.9-0.3,3s0.1,2,0.3,3c0.2,1,0.5,1.9,0.9,2.8   c0.4,0.9,0.9,1.8,1.4,2.6c0.5,0.8,1.2,1.5,1.8,2.2c0.7,0.7,1.4,1.3,2.2,1.8c1.6,1,3.4,1.8,5.3,2.2c1,0.2,1.9,0.3,3,0.3s2-0.1,3-0.3   c6.8-1.4,11.9-7.4,11.9-14.6C287.7,215,281,208.3,272.8,208.3z M381.9,208.3c-1,0-2,0.1-3,0.3c-1,0.2-1.9,0.5-2.8,0.9   c-0.9,0.4-1.8,0.9-2.6,1.4c-0.8,0.5-1.5,1.2-2.2,1.8c-1.3,1.4-2.4,3-3.2,4.8c-0.4,0.9-0.7,1.8-0.9,2.8c-0.2,1-0.3,1.9-0.3,3   s0.1,2,0.3,3c0.2,1,0.5,1.9,0.9,2.8c0.4,0.9,0.9,1.8,1.4,2.6c0.5,0.8,1.2,1.5,1.8,2.2c0.7,0.7,1.4,1.3,2.2,1.8   c0.8,0.5,1.7,1,2.6,1.4c0.9,0.4,1.8,0.7,2.8,0.9c1,0.2,1.9,0.3,3,0.3s2-0.1,3-0.3c6.8-1.4,11.9-7.4,11.9-14.6   C396.8,215,390.2,208.3,381.9,208.3z',
                        },
                    },
                ],
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const ZaloFilled = React.forwardRef(IconComponent);
ZaloFilled.displayName = 'ZaloFilled';

export { ZaloFilled };
